// reducers/projectReducer.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProjectState {
  selectedProject: string;
  selectedProjectTitle: string;
}

const initialState: ProjectState = {
  selectedProject: '',
  selectedProjectTitle: '',
};

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setSelectedProject(state, action: PayloadAction<string>) {
      state.selectedProject = action.payload;
    },
    setSelectedProjectTitle(state, action: PayloadAction<string>) {
      state.selectedProjectTitle = action.payload;
    },
  },
});


export const { setSelectedProject, setSelectedProjectTitle } = projectSlice.actions;
export default projectSlice.reducer;
